import { render, staticRenderFns } from "./AddLinkkiDialog.vue?vue&type=template&id=2702f848&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./AddLinkkiDialog.vue?vue&type=script&lang=js"
export * from "./AddLinkkiDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2702f848",
  null
  
)

export default component.exports